import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ErrorCode, Validator } from '@symphony-solo/shared/error-handling/src';
import { loadPriceLevelsSuccessAction } from '../+state';
import { PriceLevelDto } from '../dtos';

export class PriceLevelsValidator extends Validator<PriceLevelDto[]> {
  public validate(): TypedAction<any> {
    if (this.data?.length > 0) {
      return loadPriceLevelsSuccessAction({ priceLevels: this.data });
    }
    throw new AppStateFailureBuilder()
      .setFailureType(FailureType.Validation)
      .addFailure(new AppStateFailureItemWithErrorCode('No Price Levels', ErrorCode.NoPriceLevels))
      .build();
  }
}
